/**
 * Stories handled by ZillowNavbar
 */
/* eslint-disable local-rules/require-storybook-documentation */
import { FunctionComponent } from 'react';
import styled, { css } from 'styled-components';
import { StaticDomainConfiguration } from 'src/components/ZillowNavbar/page-frame-types/StaticDomainConfiguration';
import { HEADER_VERSIONS } from 'src/components/ZillowNavbar/constants';
import { getBreakpointsForHeaderVersion } from 'src/components/ZillowNavbar/utils/getBreakpointsForHeaderVersion';
import { ZillowSVGImage } from './common/ZillowSVGImage/ZillowSVGImage';

export type ZHLLogoProps = {
    staticDomain: StaticDomainConfiguration;
    version: HEADER_VERSIONS;
};

const SizedZillowSVGImage = styled(ZillowSVGImage)<Pick<ZHLLogoProps, 'version'>>`
    ${({ version }) => css`
        height: auto;
        width: 200px;
        @media (max-width: ${getBreakpointsForHeaderVersion(version).MOBILE}px) {
            width: 150px;
        }
    `}
`;
export const ZHLLogo: FunctionComponent<ZHLLogoProps> = ({ staticDomain, version }) => (
    <SizedZillowSVGImage
        version={version}
        svgFileName="zhl-logo-default"
        svgName="ZHL logo"
        staticDomain={staticDomain}
    />
);
